import {
  RequestAccessApiErrorKey,
  requestAccessApiErrors,
  useCSMSUserInfo,
  useRequestAccessMutation,
} from '@energy-stacks/csms/feature-users-data';
import { setHasRequestedAccess, useAppDispatch } from '@energy-stacks/store';
import { useESSnackbar } from '@energy-stacks/core/ui';
import { useCallback } from 'react';
import { AccessDeniedPage } from '@energy-stacks/user-access';
import { LogoOverlay } from '@energy-stacks/shared';

export const CSMSAccessDeniedPage = () => {
  const { user } = useCSMSUserInfo();

  const dispatch = useAppDispatch();

  const [requestAccess, { isLoading }] = useRequestAccessMutation();
  const { showSnackbar } = useESSnackbar();

  const handleRequestAccess = useCallback(() => {
    requestAccess()
      .unwrap()
      .then(() => {
        showSnackbar('success', 'requestAccessSuccess', 'shared');
        dispatch(setHasRequestedAccess(true));
      })
      .catch((error) => {
        showSnackbar(
          'error',
          requestAccessApiErrors[error.data?.errorCode],
          'shared'
        );

        const alreadyRequestedAccess =
          error.data?.errorCode === RequestAccessApiErrorKey.ALREADY_EXISTS;

        if (alreadyRequestedAccess) {
          dispatch(setHasRequestedAccess(true));
        }
      });
  }, [requestAccess, showSnackbar, dispatch]);

  return (
    <AccessDeniedPage
      userActive={user?.isActive ?? false}
      userHasRoleAssigned={user?.userRole !== 'noRole'}
      shouldRequestAccess={handleRequestAccess}
      requestAccessIsLoading={isLoading}
      LoadingComponent={() => <LogoOverlay />}
    />
  );
};
